import { useEffect, useRef } from "react";
import type { CanvasNodeKind } from "../nodes/node-types.js";

const labels: Record<CanvasNodeKind, string> = {
  text: "文本",
  image: "图片",
  video: "视频",
  audio: "音频",
  script: "手动脚本",
  seedance: "Seedance 生成"
};

export interface NodeQuickAddMenuProps {
  kinds: readonly CanvasNodeKind[];
  onCreate(kind: CanvasNodeKind): void;
}

export function NodeQuickAddMenu({ kinds, onCreate }: NodeQuickAddMenuProps) {
  const firstActionRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    firstActionRef.current?.focus();
  }, []);

  return (
    <div className="studio-context-menu__quick-add" role="group" aria-label="快速添加节点">
      <p>快速添加</p>
      {kinds.map((kind, index) => (
        <button
          key={kind}
          role="menuitem"
          ref={index === 0 ? firstActionRef : undefined}
          type="button"
          aria-label={`添加${labels[kind]}`}
          onClick={() => onCreate(kind)}
        >
          {labels[kind]}
        </button>
      ))}
    </div>
  );
}
